import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { BlogGrid } from "~/components/blog-grid";
import { createBrandMeta } from "~/lib/shared/meta";

export const Route = createFileRoute("/blog/")({
  head: () => {
    const metaConfig = createBrandMeta({
      title: "Dream Coach Match Blog | Coaching Tips & Insights",
      description:
        "Learn how to use Dream Coach Match to elevate your coaching practice or find the perfect coach for you. Expert insights on coaching, personal development, and professional growth.",
      ogTitle: "Dream Coach Match Blog | Coaching Tips & Insights",
      ogDescription:
        "Expert insights on coaching, personal development, and professional growth. Learn from our experience helping coaches succeed and clients find their perfect coach match.",
      ogImage: "https://dreamcoachmatch.com/img/og/blog-hero.jpg",
      ogType: "website",
      ogUrl: "https://dreamcoachmatch.com/blog",
      twitterCard: "summary_large_image",
      twitterTitle: "Dream Coach Match Blog | Coaching Tips & Insights",
      twitterDescription:
        "Expert insights on coaching, personal development, and professional growth. Learn from our experience in the coaching industry.",
      twitterImage: "https://dreamcoachmatch.com/img/og/blog-hero.jpg",
      canonical: "https://dreamcoachmatch.com/blog",
      keywords: [
        "coaching blog",
        "coaching tips",
        "personal development",
        "professional growth",
        "coach training",
        "coaching industry",
        "life coaching",
        "business coaching",
        "health coaching",
        "coaching marketplace",
      ],
      author: "Dream Coach Match",
    });

    const blogStructuredData = {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "Dream Coach Match Blog",
      description:
        "Expert insights on coaching, personal development, and professional growth from the team at Dream Coach Match.",
      url: "https://dreamcoachmatch.com/blog",
      publisher: {
        "@type": "Organization",
        name: "Dream Coach Match",
        url: "https://dreamcoachmatch.com",
        logo: "https://dreamcoachmatch.com/img/logo/dcm-horizontal-1.png",
      },
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": "https://dreamcoachmatch.com/blog",
      },
      inLanguage: "en-US",
      about: [
        "Coaching",
        "Personal Development",
        "Professional Growth",
        "Life Coaching",
        "Business Coaching",
        "Health Coaching",
      ],
    };

    const breadcrumbStructuredData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://dreamcoachmatch.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blog",
          item: "https://dreamcoachmatch.com/blog",
        },
      ],
    };

    return {
      ...metaConfig,
      scripts: [
        {
          key: "jsonld-blog",
          props: {
            type: "application/ld+json",
            dangerouslySetInnerHTML: JSON.stringify(blogStructuredData),
          },
        },
        {
          key: "jsonld-breadcrumb",
          props: {
            type: "application/ld+json",
            dangerouslySetInnerHTML: JSON.stringify(breadcrumbStructuredData),
          },
        },
      ],
    };
  },
  component: BlogPage,
});

function BlogPage() {
  return (
    <div className="mx-auto min-h-screen max-w-screen-md px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <h1 className="font-heading mb-8 text-3xl text-black sm:text-4xl">
        Dream Coach Match Blog
      </h1>
      <p className="text-text-secondary mb-8 text-lg">
        Learn from our experience on helping coaches succeed with Dream Coach
        Match, and helping clients find the perfect coach for them.
      </p>
      <BlogGrid
        query={{
          "data.tags": { $not: { $elemMatch: { $eq: "for-members" } } },
        }}
      />
    </div>
  );
}
